// extracted by css-extract-rspack-plugin
var _1 = "oWgATWy2TgYnCPAM";
var _2 = "UtSrMWUPrrU1EVh6";
var _3 = "rVxNpETrzgGd9tA1";
export { _1 as "closeIcon", _2 as "dsTooltip", _3 as "message" }
// extracted by css-extract-rspack-plugin
var _1 = "oWgATWy2TgYnCPAM";
var _2 = "UtSrMWUPrrU1EVh6";
var _3 = "rVxNpETrzgGd9tA1";
export { _1 as "closeIcon", _2 as "dsTooltip", _3 as "message" }
